import { EAssetMaintainer, type ILiability } from 'findef';

export type TLiabilityMaintained = EAssetMaintainer.PROVIDER | EAssetMaintainer.MANUAL;

export const getMaintainedText = (liability: ILiability): TLiabilityMaintained => {
  if (liability?.providerImport) {
    return EAssetMaintainer.PROVIDER;
  }
  return EAssetMaintainer.MANUAL;
};
